import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: ['dark', 'light'],
      spacing: ['gutter', 'margin', 'offset']
    },
    classGroups: {
      'font-size': [
        'text-small',
        'text-upper-small',
        'text-main-title-default',
        'text-breadcrumbs',
        'text-button',
        'text-s-standard',
        'text-d-standard',
        'text-medium-upper',
        'text-big-quote',
        'text-s-big-quote',
        'text-m-big-quote',
        'text-d-big-quote',
        'text-s-big-100',
        'text-d-big-100',
        'text-s-hero-tb-customized',
        'text-d-hero-tb-customized',
        'text-history-size-body'
      ]
    }
  }
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
